export default __webpack_public_path__ + "static/media/tool_item_3.0ed20f32.png";